<ion-button
  [fill]="fill"
  [class]="buttonClass"
  [disabled]="isDisabled"
  [ngClass]="hostClass"
  (click)="onClick($event)"
  mode="md"
>
  <ng-content></ng-content>
</ion-button>
